module.exports = __webpack_public_path__ + "img/gi.9f6682c1.svg";